import { useEffect, useState } from 'react'

const useBackActionModalListener = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const onPopstate = () => {
    setIsModalOpen(true)
  }

  useEffect(() => {
    if (isModalOpen) {
      closeModal()
    }

    history.pushState(null, '', null)
    window.addEventListener('popstate', onPopstate)

    return () => {
      window.removeEventListener('popstate', onPopstate)
    }
  }, [])

  const closeModal = () => {
    setIsModalOpen(false)
    // モーダルを閉じたときにヒストリースタックを元に戻す
    window.history.back()
  }

  return {
    isModalOpen,
    closeModal,
  }
}

export default useBackActionModalListener
